import React from 'react';
import ContentLoader from 'react-content-loader';

import { createStyles, Paper, Theme, withStyles, WithStyles } from '@material-ui/core';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    root: {
      height: `${unit * 10 - 2}px`,
      marginBottom: unit,
    },
    wrapper: {
      width: 400,
      height: '100%',
      paddingTop: `${unit * 2 + 4}px`,
      paddingLeft: `${unit * 2}px`,
    },
  });

interface ActivitiesScreenItemLoaderProps extends WithStyles<typeof styles> {}

const ActivitiesScreenItemLoader: React.FC<ActivitiesScreenItemLoaderProps> = ({ classes }) => (
  <Paper elevation={1} className={classes.root}>
    <div className={classes.wrapper}>
      <ContentLoader width={400} height={40} speed={2} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
        <rect x="59" y="4" rx="4" ry="4" width="400" height="10" />
        <rect x="59" y="30" rx="3" ry="3" width="200" height="8" />
        <circle cx="20" cy="20" r="20" />
      </ContentLoader>
    </div>
  </Paper>
);

export default withStyles(styles)(ActivitiesScreenItemLoader);
